import { Country } from "../../earth/model/country";
import { KeyedMetrics } from "./keyedMetrics";
import { MetricsByBrand } from "./metricsByBrand";

export class MetricsByCountry {
    private _metrics = new Map<string, MetricsByBrand>();

    get countryIsoCodes(): string[] {
        return [...this._metrics.keys()];
    }

    getMetricsForCountry(country: Country): MetricsByBrand {
        return this._metrics.get(country.isoCode) || new MetricsByBrand();
    }

    setMetricsForCountry(country: Country, metrics: MetricsByBrand) {
        this._metrics.set(country.isoCode, metrics);
    }

    setMetricsForCountryIsoCode(countryIsoCode: string, metrics: MetricsByBrand) {
        this._metrics.set(countryIsoCode, metrics);
    }

    aggregateMetricsForCountries(countries: Country[]): MetricsByBrand {
        let aggregate = new MetricsByBrand();
        let countryMetrics = countries.map(it => this.getMetricsForCountry(it));
        for (let metrics of countryMetrics) {
            aggregate.aggregateFrom(metrics);
        }
        return aggregate;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/app/model/metricsByCountry.ts